/* eslint-disable react/no-children-prop */
import { Redirect, Route, Switch } from 'react-router-dom';

import React from 'react';
// import SignUp from './SignUp';
// import SignUpConfirm from './SignUpConfirm';
import SignUpResend from './SignUpResend';
import UnauthenticatedPaths from '../UnauthenticatedRoutes.paths';
import { connect } from 'react-redux';
import { mapStateToProps } from './SignUpRoutes.container';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps)(SignUpRoutes);

export function SignUpRoutes() {
    return (
        <Switch>
            {/**
             * The SignUpResend route is a hidden route that can be used to resend the sign-up confirmation email.
             * This is for users who's temporary password expired after the 7-day sign in period.
             */}
            <Route exact path={UnauthenticatedPaths.SIGN_UP_RESEND} children={<SignUpResend />} />
            {/**
             * The following routes should be re-visited when we allow self sign-up
            <Route exact path={UnauthenticatedPaths.SIGN_UP_CONFIRM} children={<SignUpConfirm />} />
            <Route exact path={`${UnauthenticatedPaths.SIGN_UP}`} children={<SignUp />} />
            <Route children={<Redirect to={UnauthenticatedPaths.SIGN_UP} />} />
            */}
            <Route children={<Redirect to={UnauthenticatedPaths.SIGN_IN} />} />
        </Switch>
    );
}
